import { render, staticRenderFns } from "./PrismicProduct.vue?vue&type=template&id=65adea6c&scoped=true&"
import script from "./PrismicProduct.vue?vue&type=script&lang=js&"
export * from "./PrismicProduct.vue?vue&type=script&lang=js&"
import style0 from "./PrismicProduct.vue?vue&type=style&index=0&id=65adea6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65adea6c",
  null
  
)

export default component.exports